export const onExpandIndex = (index: number, expandedIndexes: number[]) => {
  if (expandedIndexes.includes(index)) {
    const newIndexes = expandedIndexes.filter(value => value !== index);
    return newIndexes;
  } else {
    return [...expandedIndexes, index];
  }
};
